<template>
  <div style="width: 100%">
    <table class="ui striped selectable table">
      <thead>
        <tr>
          <th>#</th>
          <th v-if="showSchool">School</th>
          <th>Period</th>
          <th>Student count</th>
          <th>Type</th>
          <th>Cost (inc VAT)</th>
          <th v-if="!showPaidDate">Due on</th>
          <th>Paid</th>
          <th v-if="showPaidDate">Paid on</th>
          <th v-if="!showPaidDate">Remaining balance</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr v-if="!licenses || licenses.length == 0">
          <td></td>
          <td colspan="4">No licenses found</td>
        </tr>
        <license-table-row
          v-for="license in licenses"
          v-bind:license="license"
          v-bind:key="license.Id"
          v-bind:actions="actions"
          v-on:action="rowAction"
          v-bind:showSchool="showSchool"
          v-bind:showPaidDate="showPaidDate"
        />
      </tbody>
    </table>
  </div>
</template>

<script>
import LicenseTableRow from '@/components/licenses/LicenseTableRow';

export default {
  name: 'LicensesTable',
  computed: {},
  components: { LicenseTableRow },
  props: ['licenses', 'actions', 'showSchool', 'showPaidDate'],
  methods: {
    rowAction(action) {
      this.$emit('rowAction', action);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/licenses/LicensesTable.vue